import React from "react";
import "../scss/books.scss";
import "../scss/desktopbooks.scss";

const ToastBotAvatar = (props) => {

  return <div className="toast"></div>;
};

export default ToastBotAvatar;
